import { render, staticRenderFns } from "./Publish.vue?vue&type=template&id=5bf11e08&scoped=true&"
import script from "./Publish.vue?vue&type=script&lang=ts&"
export * from "./Publish.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf11e08",
  null
  
)

export default component.exports